export enum ReactQueryKeys {
    basket_summary = "basket__summary",
    vouchers_useOrderDetails = "vouchers__useOrderDetails",
}
